/* eslint-disable react/jsx-props-no-spreading */
import type { UseComboboxPropGetters } from 'downshift';
import type { FunctionComponent } from 'react';
import type { CommandPaletteSearchResult } from '../../../shared/CommandPalette/types';
import styles from './Results.module.less';

type Props = ReturnType<UseComboboxPropGetters<CommandPaletteSearchResult>['getMenuProps']>;

/**
 * Container for search results
 */
const Results: FunctionComponent<Props> = ({ children, ...props }) => {
  return (
    <div className={styles.results}>
      <ul {...props} className={styles.resultsList}>
        {children}
      </ul>
    </div>
  );
};

export default Results;
